<template>
  <div class="membership_manage_width">
    <div class="pa-3 pl-10" :style="{ display: display_type }">
      <p class="display-1 mt-7">멤버십 설정/관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쿠팡,네이버,G마켓,옥션등 기타 마켓에서 제공하는 멤버십 서비스와 같이
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        우리 쇼핑몰만의 멤버십을 만들어 회원들에게 제공할 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정기결제의 경우 사용중인 PG사에 신청하여 사용이 가능합니다 . (올앳,
        이니시스, KCP, 토스페이먼츠 가능)
      </p>
    </div>
    <v-container class="pl-10 pr-10" :style="{ display: display_type }">
      <MembershipReStep ref="MembershipReStep"></MembershipReStep>
    </v-container>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>
<style scoped>
.container {
  max-width: 100%;
}
</style>
<script>
import MembershipReStep from "@/components/membership/membership_manage/MembershipReStep.vue";
import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  data() {
    return {
      display_type: "none",
    };
  },
  methods: {
    progressShow: function() {
      this.display_type = "none";
      this.$refs.PageLoadingProgress.show();
    },
    progressHide: function() {
      this.display_type = "block";
      this.$refs.PageLoadingProgress.hide();
    },
  },

  mounted: function() {
    this.progressShow();
  },
  components: {
    MembershipReStep,
    PageLoadingProgress,
  },
};
</script>
